<template>
  <div>
    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <salvar-canal-dialog
      :is-dialog-open.sync="isDialogOpen"
      @refetch-data="getCanais"
    />

    <v-card>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-end"
          >
            <v-btn
              title
              color="success"
              @click.stop="isDialogOpen = !isDialogOpen"
            >
              <v-icon
                left
                size="25"
              >
                {{ icons.mdiPlus }}
              </v-icon>

              <span>Criar canal</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <table-canais
              :items="canais"
              :loading="loading"
              @refetch-data="getCanais"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import { onMounted, ref } from '@vue/composition-api'
import Contadores from '@/components/contadores/Contadores.vue'
import SalvarCanalDialog from '@/views/canal/SalvarCanalDialog.vue'
import TableCanais from '@/components/tables/TableCanais.vue'
import CanalService from '@/services/modules/CanalService'

export default {
  components: {
    Contadores,
    SalvarCanalDialog,
    TableCanais,
  },

  setup() {
    const isDialogOpen = ref(false)
    const canais = ref([])
    const loading = ref(false)
    const filtroStatus = ref('')
    const contadores = ref({
      total: 0,
      ativos: 0,
      inativos: 0,
    })

    async function getCanais() {
      if (loading.value) return

      try {
        loading.value = true

        canais.value = await CanalService.get()

        contadores.value.total = canais.value.length
        contadores.value.ativos = canais.value.filter(it => it.ativo).length
        contadores.value.inativos = canais.value.filter(it => !it.ativo).length

        if (filtroStatus.value) {
          canais.value = canais.value.filter(e => e.ativo === filtroStatus.value || e.ativo.toString() === filtroStatus.value)
        }
      } finally {
        loading.value = false
      }
    }
    onMounted(getCanais)

    function atualizarFiltro(item) {
      filtroStatus.value = item
      getCanais()
    }

    return {
      isDialogOpen,
      canais,
      loading,
      contadores,
      getCanais,
      atualizarFiltro,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>
